<!-- The inner input is plain (NO matInput) because *this component* is the MatFormFieldControl -->
<input
  #inputEl
  class="custom-datepicker-input"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  [attr.id]="id"
  [attr.placeholder]="placeholder"
  [attr.aria-describedby]="describedBy"
  [attr.aria-haspopup]="'dialog'"
  [readonly]="true"
  [disabled]="disabled || readonly"
  [value]="(displayValue | uppercase) ?? null"
  (click)="openOverlay()"
  (keydown.enter)="openOverlay()" />

<!-- Connected overlay with calendar -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="overlayOpen"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="mat-overlay-transparent-backdrop"
  [cdkConnectedOverlayPanelClass]="['mat-elevation-z2', 'bordered-pane']"
  [cdkConnectedOverlayOffsetY]="20"
  (overlayOutsideClick)="closeOverlay()">
  <div class="calendar-pane">
    <div class="calendar-wrapper">
      <mat-calendar
        [dateClass]="displayAiracDates() ? airacDateClass : dateClass"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [selected]="value"
        [startAt]="startAt"
        [dateFilter]="dateFilter"
        (selectedChange)="onSelected($event)">
      </mat-calendar>
    </div>

    <div class="custom-content-wrapper">
      <div class="wrapper-date-action">
        <div class="row time-format">
          <div class="displayed-format">
            <mat-label>UTC date time</mat-label>
            <p>{{ formatWithZone(value, "UTC") }}</p>
          </div>

          @if (timezone() !== 'UTC') {
          <div class="displayed-format">
            <mat-label
              >Selected timezone <span>({{ timezone() }})</span></mat-label
            >
            <p>{{ formatWithZone(value, timezone()) }}</p>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
